import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { PointOfInterest } from './types'
import { RootState } from '../types'

export const state: PointOfInterest = {
  filterPointsOfInterest: [],
  filterPoints: [],
  responseMessage: '',
  responseError: false,
  geocodeResult: '',
  pointOfInterestGeoCoordinates: { lat: null, lng: null }
}

const namespaced = true

export const pointOfInterest: Module<PointOfInterest, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
